unit Province;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, Vcl.StdCtrls,
  WEBLib.StdCtrls, VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, WEBLib.Buttons,
  Vcl.Controls, WEBLib.ExtCtrls, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, VCL.TMSFNCBitmapContainer;

type
  TfrmProvince = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebPanel4: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    dgProvince: TTMSFNCDataGrid;
    WebButton1: TButton;
    wcProvince: TXDataWebClient;
    wdsProvince: TXDataWebDataSet;
    dsProvince: TDataSource;
    dgdbaProvince: TTMSFNCDataGridDatabaseAdapter;
    TMSFNCBitmapContainer1: TTMSFNCBitmapContainer;
    WebButton2: TButton;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    edtProvincePC: TEdit;
    WebSpeedButton8: TSpeedButton;
    WebSpeedButton9: TSpeedButton;
    wdsProvinceNo: TIntegerField;
    wdsProvinceName: TStringField;
    wdsProvinceCOUNTRYNO: TIntegerField;
    procedure WebFormShow(Sender: TObject);
    procedure dgProvinceCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton2Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
  private
    { Private declarations }

    iProvincePC, iProvinceMaxPC : Integer;

    procedure LoadProvince;

  public
    { Public declarations }
    sProvince : String;
    iProvinceNo : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmProvince: TfrmProvince;

implementation

{$R *.dfm}
uses
  share.classes, share.common, stfmssystem.connection, ProvinceSetup ;

{ TfrmProvince }

procedure TfrmProvince.dgProvinceCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  iProvinceNo := dgdbaProvince.FieldAtColumn[0].AsInteger;
  sProvince := dgdbaProvince.FieldAtColumn[1].AsString;
end;

procedure TfrmProvince.LoadProvince;
  procedure OnError(Error: TXDataClientError);
    begin
      LoadProvince;
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadProvince;
        end
      else
        begin
          wdsProvince.Close;
          wdsProvince.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsProvince.Open;

          console.log(GetJsonFromDataSet(wdsProvince));
        end;
    end;

  procedure OnSuccessPC(Response : TXDataClientResponse);
    var
      ProvinceParams : TProvinceParams;
      sProvince : String;
    begin
      iProvinceMaxPC := Integer(TJSObject(Response.Result)['value']);

      edtProvincePC.Text := IntToStr(iProvincePC) + ' of ' + IntToStr(iProvinceMaxPC);

      ProvinceParams := TProvinceParams.Create;
      ProvinceParams.PageCount := iProvincePC;

      sProvince := ConvertObjToJson(ProvinceParams).ToString;

      wcProvince.RawInvoke('IstfmsloadsService.Get_Province_View',[sProvince],@OnSuccess,@OnError);
    end;

begin
  wcProvince.RawInvoke('IstfmsloadsService.Get_Province_MaxPC',[],@OnSuccessPC,@OnError);
end;

procedure TfrmProvince.WebButton1Click(Sender: TObject);
begin
  sProvince := '';
  iProvinceNo := 0;
  Close;
end;

procedure TfrmProvince.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmProvince.WebFormShow(Sender: TObject);
begin
  iProvincePC := 1;
  LoadProvince;
end;

procedure TfrmProvince.WebSpeedButton5Click(Sender: TObject);
var
  sProvince : String;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Province Successfully Saved');
      Close;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;
begin

  sProvince := InputBox('Province','Enter a new Province','');

  wdsProvince.Insert;
  wdsProvince.FieldByName('Name').AsString := sProvince;

  wcProvince.RawInvoke('IstfmsloadsService.Put_Province_Insert',[GetJsonFromDataSet(wdsProvince)],@OnSuccess,@OnError);

end;

procedure TfrmProvince.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  edtProvincePC := TEdit.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  dgProvince := TTMSFNCDataGrid.Create(Self);
  dgdbaProvince := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  TMSFNCBitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  wcProvince := TXDataWebClient.Create(Self);
  wdsProvince := TXDataWebDataSet.Create(Self);
  wdsProvinceNo := TIntegerField.Create(Self);
  wdsProvinceName := TStringField.Create(Self);
  wdsProvinceCOUNTRYNO := TIntegerField.Create(Self);
  dsProvince := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  edtProvincePC.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  dgProvince.BeforeLoadDFMValues;
  dgdbaProvince.BeforeLoadDFMValues;
  TMSFNCBitmapContainer1.BeforeLoadDFMValues;
  wcProvince.BeforeLoadDFMValues;
  wdsProvince.BeforeLoadDFMValues;
  wdsProvinceNo.BeforeLoadDFMValues;
  wdsProvinceName.BeforeLoadDFMValues;
  wdsProvinceCOUNTRYNO.BeforeLoadDFMValues;
  dsProvince.BeforeLoadDFMValues;
  try
    Name := 'frmProvince';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 480;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Province Information';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 420;
    WebPanel3.Width := 640;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 136;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Close';
    WebButton1.Color := clSkyBlue;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 16;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Select';
    WebButton2.Color := clGreenyellow;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebSpeedButton6.SetParentComponent(WebPanel3);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 240;
    WebSpeedButton6.Top := 16;
    WebSpeedButton6.Width := 24;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Caption := '<<';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 2;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    WebSpeedButton7.SetParentComponent(WebPanel3);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 270;
    WebSpeedButton7.Top := 16;
    WebSpeedButton7.Width := 24;
    WebSpeedButton7.Height := 24;
    WebSpeedButton7.Caption := '<';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 3;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    edtProvincePC.SetParentComponent(WebPanel3);
    edtProvincePC.Name := 'edtProvincePC';
    edtProvincePC.Left := 300;
    edtProvincePC.Top := 16;
    edtProvincePC.Width := 60;
    edtProvincePC.Height := 22;
    edtProvincePC.Alignment := taCenter;
    edtProvincePC.ChildOrder := 7;
    edtProvincePC.HeightPercent := 100.000000000000000000;
    edtProvincePC.Text := '1 of 1';
    edtProvincePC.WidthPercent := 100.000000000000000000;
    WebSpeedButton8.SetParentComponent(WebPanel3);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 366;
    WebSpeedButton8.Top := 16;
    WebSpeedButton8.Width := 24;
    WebSpeedButton8.Height := 24;
    WebSpeedButton8.Caption := '>';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 5;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    WebSpeedButton9.SetParentComponent(WebPanel3);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 396;
    WebSpeedButton9.Top := 16;
    WebSpeedButton9.Width := 24;
    WebSpeedButton9.Height := 24;
    WebSpeedButton9.Caption := '>>';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.TabOrder := 6;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    WebPanel4.SetParentComponent(WebPanel1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 60;
    WebPanel4.Width := 640;
    WebPanel4.Height := 53;
    WebPanel4.Align := alTop;
    WebPanel4.ChildOrder := 2;
    WebPanel4.Color := clSilver;
    WebPanel4.TabOrder := 2;
    WebSpeedButton1.SetParentComponent(WebPanel4);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 16;
    WebSpeedButton1.Top := 6;
    WebSpeedButton1.Width := 40;
    WebSpeedButton1.Height := 40;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    WebSpeedButton2.SetParentComponent(WebPanel4);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 62;
    WebSpeedButton2.Top := 6;
    WebSpeedButton2.Width := 40;
    WebSpeedButton2.Height := 40;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    WebSpeedButton3.SetParentComponent(WebPanel4);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 108;
    WebSpeedButton3.Top := 6;
    WebSpeedButton3.Width := 40;
    WebSpeedButton3.Height := 40;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    WebSpeedButton4.SetParentComponent(WebPanel4);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 154;
    WebSpeedButton4.Top := 6;
    WebSpeedButton4.Width := 40;
    WebSpeedButton4.Height := 40;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    WebSpeedButton5.SetParentComponent(WebPanel4);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 200;
    WebSpeedButton5.Top := 6;
    WebSpeedButton5.Width := 40;
    WebSpeedButton5.Height := 40;
    WebSpeedButton5.Caption := '+';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 4;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    dgProvince.SetParentComponent(WebPanel1);
    dgProvince.Name := 'dgProvince';
    dgProvince.Left := 0;
    dgProvince.Top := 113;
    dgProvince.Width := 640;
    dgProvince.Height := 307;
    dgProvince.Align := alClient;
    dgProvince.ParentDoubleBuffered := False;
    dgProvince.DoubleBuffered := True;
    dgProvince.TabOrder := 3;
    dgProvince.ShowAcceleratorChar := False;
    dgProvince.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgProvince.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgProvince.Header.VisualGrouping.Layout.Font.Height := -12;
    dgProvince.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgProvince.Header.VisualGrouping.Layout.Font.Style := [];
    dgProvince.Adapter := dgdbaProvince;
    dgProvince.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgProvince.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgProvince.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgProvince.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgProvince.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgProvince.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgProvince.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgProvince.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgProvince.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgProvince.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgProvince.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgProvince.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgProvince.CellAppearance.BandLayout.Font.Height := -12;
    dgProvince.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgProvince.CellAppearance.BandLayout.Font.Style := [];
    dgProvince.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgProvince.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgProvince.CellAppearance.FixedLayout.Font.Height := -12;
    dgProvince.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgProvince.CellAppearance.FixedLayout.Font.Style := [];
    dgProvince.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgProvince.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgProvince.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgProvince.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgProvince.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgProvince.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgProvince.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgProvince.CellAppearance.FocusedLayout.Font.Height := -12;
    dgProvince.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgProvince.CellAppearance.FocusedLayout.Font.Style := [];
    dgProvince.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgProvince.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgProvince.CellAppearance.GroupLayout.Font.Height := -12;
    dgProvince.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgProvince.CellAppearance.GroupLayout.Font.Style := [];
    dgProvince.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgProvince.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgProvince.CellAppearance.NormalLayout.Font.Height := -12;
    dgProvince.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgProvince.CellAppearance.NormalLayout.Font.Style := [];
    dgProvince.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgProvince.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgProvince.CellAppearance.SelectedLayout.Font.Height := -12;
    dgProvince.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgProvince.CellAppearance.SelectedLayout.Font.Style := [];
    dgProvince.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgProvince.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgProvince.CellAppearance.SummaryLayout.Font.Height := -12;
    dgProvince.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgProvince.CellAppearance.SummaryLayout.Font.Style := [];
    dgProvince.ColumnCount := 3;
    dgProvince.Columns.Clear;
    with dgProvince.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'No';
    end;
    with dgProvince.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
    end;
    with dgProvince.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'COUNTRYNO';
    end;
    dgProvince.Designer := False;
    dgProvince.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgProvince.FilterAppearance.Font.Color := clWindowText;
    dgProvince.FilterAppearance.Font.Height := -12;
    dgProvince.FilterAppearance.Font.Name := 'Segoe UI';
    dgProvince.FilterAppearance.Font.Style := [];
    dgProvince.Icons.ExpandIcon.LoadFromFile('Province.WebPanel1.dgProvince.Icons.ExpandIcon.svg');
    dgProvince.Icons.CollapseIcon.LoadFromFile('Province.WebPanel1.dgProvince.Icons.CollapseIcon.svg');
    dgProvince.Icons.FilterIcon.LoadFromFile('Province.WebPanel1.dgProvince.Icons.FilterIcon.svg');
    dgProvince.Icons.FilterActiveIcon.LoadFromFile('Province.WebPanel1.dgProvince.Icons.FilterActiveIcon.svg');
    dgProvince.Icons.FilterClearIcon.LoadFromFile('Province.WebPanel1.dgProvince.Icons.FilterClearIcon.svg');
    dgProvince.Icons.FilterTypeIcon.LoadFromFile('Province.WebPanel1.dgProvince.Icons.FilterTypeIcon.svg');
    dgProvince.Icons.SortAscendingIcon.LoadFromFile('Province.WebPanel1.dgProvince.Icons.SortAscendingIcon.svg');
    dgProvince.Icons.SortDescendingIcon.LoadFromFile('Province.WebPanel1.dgProvince.Icons.SortDescendingIcon.svg');
    dgProvince.Icons.CloseIcon.LoadFromFile('Province.WebPanel1.dgProvince.Icons.CloseIcon.svg');
    SetEvent(dgProvince, Self, 'OnCellClick', 'dgProvinceCellClick');
    dgProvince.RowCount := 1;
    dgdbaProvince.SetParentComponent(dgProvince);
    dgdbaProvince.Name := 'dgdbaProvince';
    dgdbaProvince.Left := 280;
    dgdbaProvince.Top := 56;
    dgdbaProvince.Width := 26;
    dgdbaProvince.Height := 26;
    dgdbaProvince.Visible := True;
    dgdbaProvince.Columns.Clear;
    with dgdbaProvince.Columns.Add do
    begin
      FieldName := 'No';
      Header := 'No';
      AutoCreated := False;
    end;
    with dgdbaProvince.Columns.Add do
    begin
      FieldName := 'Name';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdbaProvince.Columns.Add do
    begin
      FieldName := 'COUNTRYNO';
      Header := 'COUNTRYNO';
      AutoCreated := False;
    end;
    dgdbaProvince.DataSource := dsProvince;
    TMSFNCBitmapContainer1.SetParentComponent(Self);
    TMSFNCBitmapContainer1.Name := 'TMSFNCBitmapContainer1';
    TMSFNCBitmapContainer1.Left := 544;
    TMSFNCBitmapContainer1.Top := 16;
    TMSFNCBitmapContainer1.Width := 26;
    TMSFNCBitmapContainer1.Height := 26;
    TMSFNCBitmapContainer1.Visible := True;
    wcProvince.SetParentComponent(Self);
    wcProvince.Name := 'wcProvince';
    wcProvince.Connection := dmData.dbConnect;
    wcProvince.Left := 88;
    wcProvince.Top := 169;
    wdsProvince.SetParentComponent(Self);
    wdsProvince.Name := 'wdsProvince';
    wdsProvince.Connection := dmData.dbConnect;
    wdsProvince.Left := 152;
    wdsProvince.Top := 169;
    wdsProvinceNo.SetParentComponent(wdsProvince);
    wdsProvinceNo.Name := 'wdsProvinceNo';
    wdsProvinceNo.FieldName := 'No';
    wdsProvinceName.SetParentComponent(wdsProvince);
    wdsProvinceName.Name := 'wdsProvinceName';
    wdsProvinceName.FieldName := 'Name';
    wdsProvinceCOUNTRYNO.SetParentComponent(wdsProvince);
    wdsProvinceCOUNTRYNO.Name := 'wdsProvinceCOUNTRYNO';
    wdsProvinceCOUNTRYNO.FieldName := 'COUNTRYNO';
    dsProvince.SetParentComponent(Self);
    dsProvince.Name := 'dsProvince';
    dsProvince.DataSet := wdsProvince;
    dsProvince.Left := 216;
    dsProvince.Top := 169;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    edtProvincePC.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    dgProvince.AfterLoadDFMValues;
    dgdbaProvince.AfterLoadDFMValues;
    TMSFNCBitmapContainer1.AfterLoadDFMValues;
    wcProvince.AfterLoadDFMValues;
    wdsProvince.AfterLoadDFMValues;
    wdsProvinceNo.AfterLoadDFMValues;
    wdsProvinceName.AfterLoadDFMValues;
    wdsProvinceCOUNTRYNO.AfterLoadDFMValues;
    dsProvince.AfterLoadDFMValues;
  end;
end;

end.